import GlossaryTableOfContents from './GlossaryTableOfContents';
import GlossarySidebarCta from './GlossarySidebarCta';
import GlossaryRelatedTerms from './GlossaryRelatedTerms';

const GlossarySidebar = ({ content, sidebarCta, relatedTerms, locale }) => {
  return (
    <aside className="flex flex-col gap-6 xl:sticky xl:top-[88px] xl:self-start">
      <GlossaryTableOfContents content={content} />
      {sidebarCta && <GlossarySidebarCta {...sidebarCta} />}
      <GlossaryRelatedTerms terms={relatedTerms} locale={locale} />
    </aside>
  );
};

export default GlossarySidebar;
